(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/stream-player/assets/javascripts/video-ended-buttons.js') >= 0) return;  svs.modules.push('/components/racing/stream-player/assets/javascripts/video-ended-buttons.js');

'use strict';

const {
  Button
} = svs.ui;
const VideoEndedButtons = _ref => {
  let {
    handleVideoEndedBtnClick
  } = _ref;
  return React.createElement("div", {
    className: "video-ended"
  }, React.createElement("div", {
    className: "video-ended-button-container"
  }, React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    onClick: () => handleVideoEndedBtnClick(true),
    size: 300
  }, "Spela upp livestreamen"), React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    inverted: true,
    onClick: () => handleVideoEndedBtnClick(false),
    size: 300,
    transparent: true
  }, "Spela upp loppet igen")));
};
svs.racing.streamplayer.VideoEndedButtons = VideoEndedButtons;

 })(window);